<template>
    <div class="login-container">
        <div class="form-side">
            <div class="login-box">
                <div class="logo">
                    <img src="@/assets/logo.png" alt="Logo Weeduc" />
                </div>
                <!-- <h2 class="titulo-ativar-conta">Ativar Conta</h2> -->
                <small class="descricao-ativar-conta">
                    Para redefinir sua senha, preencha os campos abaixo com seu email e defina uma nova senha. Após a redefinição, você poderá acessar todos os recursos da plataforma.
                </small>
                <form @submit.prevent="handleActivateAccount">
                    <div class="form-group">
                        <label>Senha</label>
                        <div class="password-input">
                            <input 
                                :type="showPassword ? 'text' : 'password'"
                                v-model="password"
                                @input="validatePassword"
                                placeholder="Sua senha (mínimo 8 caracteres)"
                                required
                                minlength="8"
                                :class="{ 'error': passwordError }"
                            />
                            <span class="password-toggle" @click="togglePassword">
                                <fa :icon="showPassword ? 'eye-slash' : 'eye'" />
                            </span>
                        </div>
                        <div v-if="passwordError" class="field-error">
                            {{ passwordError }}
                        </div>
                        <div v-if="passwordValid && password" class="field-success">
                            ✓ Senha válida
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Repetir Senha</label>
                        <div class="password-input">
                            <input 
                                :type="showConfirmPassword ? 'text' : 'password'"
                                v-model="confirmPassword"
                                @input="validateConfirmPassword"
                                placeholder="Repita sua senha (mínimo 8 caracteres)"
                                required
                                minlength="8"
                                :class="{ 'error': confirmPasswordError }"
                            />
                            <span class="password-toggle" @click="toggleConfirmPassword">
                                <fa :icon="showConfirmPassword ? 'eye-slash' : 'eye'" />
                            </span>
                        </div>
                        <div v-if="confirmPasswordError" class="field-error">
                            {{ confirmPasswordError }}
                        </div>
                        <div v-if="confirmPasswordValid && confirmPassword" class="field-success">
                            ✓ Senhas coincidem
                        </div>
                    </div>
                    <div v-if="errorMessage" class="alert alert-danger" style="margin-bottom: 10px;">
                        {{ errorMessage }}
                    </div>
                    <div v-if="successMessage" class="alert alert-success" style="margin-bottom: 10px;">
                        {{ successMessage }}
                    </div>
                    <button type="submit" class="btn-login">Ativar Conta</button>
                </form>
            </div>
        </div>
        <div class="banner-side">
            <div class="banner-content">
                <!-- <h1>Bem-vindo à Plataforma</h1>
                <p>Acesse os melhores conteúdos educacionais</p> -->
            </div>
        </div>
    </div>
</template>

<script>
import apiPassword from '@/utils/password.js';
export default {
    data() {
        return {
            password: '',
            confirmPassword: '',
            showPassword: false,
            showConfirmPassword: false,
            errorMessage: '',
            successMessage: '',
            token: '',
            passwordError: '',
            confirmPasswordError: '',
            passwordValid: false,
            confirmPasswordValid: false
        }
    },
    mounted() {
        // Captura o token da URL
        this.token = this.$route.params.slug;
    },
    methods: {
        togglePassword() {
            this.showPassword = !this.showPassword;
        },
        toggleConfirmPassword() {
            this.showConfirmPassword = !this.showConfirmPassword;
        },
        validatePassword() {
            this.passwordError = '';
            this.passwordValid = false;
            
            if (this.password.length > 0 && this.password.length < 8) {
                this.passwordError = `Senha muito curta (${this.password.length}/8 caracteres)`;
            } else if (this.password.length >= 8) {
                this.passwordValid = true;
            }
            
            // Revalidar confirmação de senha se já foi digitada
            if (this.confirmPassword) {
                this.validateConfirmPassword();
            }
        },
        validateConfirmPassword() {
            this.confirmPasswordError = '';
            this.confirmPasswordValid = false;
            
            if (this.confirmPassword.length > 0 && this.confirmPassword.length < 8) {
                this.confirmPasswordError = `Senha muito curta (${this.confirmPassword.length}/8 caracteres)`;
            } else if (this.confirmPassword.length >= 8) {
                if (this.password && this.password !== this.confirmPassword) {
                    this.confirmPasswordError = 'As senhas não coincidem';
                } else if (this.password && this.password === this.confirmPassword) {
                    this.confirmPasswordValid = true;
                }
            }
        },
        async handleActivateAccount() {
            this.errorMessage = '';
            this.successMessage = '';

            if ( !this.password || !this.confirmPassword) {
                this.errorMessage = 'Preencha todos os campos.';
                return;
            }

            if (this.password.length < 8) {
                this.errorMessage = 'A senha deve ter pelo menos 8 caracteres.';
                return;
            }

            if (this.password !== this.confirmPassword) {
                this.errorMessage = 'As senhas não coincidem.';
                return;
            }
            // Pega o token da URL
            const urlToken = this.$route.params.slug;
            
            const payload = {
                password: this.password,
                token: urlToken
            }
            try {
                await apiPassword.activateAccount(payload);
                this.successMessage = 'Conta ativada com sucesso! Você já pode fazer login.';
                setTimeout(() => {
                    this.$router.push('/portal');
                }, 2000);
            } catch (error) {
                this.errorMessage = 'Erro ao ativar a conta. Tente novamente.';
            }
        }
    }
}
</script>

<style scoped>
.login-container {
    display: flex;
    min-height: 100vh;
}

.banner-side {
    flex: 1;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    position: relative;
}

.banner-content {
    position: relative;
    text-align: center;
    padding: 1.25rem;
}

.banner-content h1 {
    font-size: 2.5em;
    margin-bottom: 0.9375rem;
}

.form-side {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    padding: 2.5rem;
    width: 35%;
}

.login-box {
    width: 100%;
    max-width: 28rem;
    background: white;
    padding: 3rem;
    border-radius: 0.5rem;
    box-shadow: 0 0.125rem 0.625rem rgba(0,0,0,0.1);
}

.logo {
    text-align: center;
    margin-bottom: 1.875rem;
}

.logo img {
    width: 12.5rem;
}

h2 {
    text-align: center;
    color: #272f3a;
    margin-bottom: 1.875rem;
}

.form-group {
    margin-bottom: 2rem;
}

label {
    display: block;
    margin-bottom: 0.5rem;
    color: #757e8a;
}

input {
    width: 100%;
    padding: 1rem 3rem 1rem 1rem;
    border: 0.0625rem solid #ddd;
    border-radius: 0.25rem;
    font-size: 1rem;
    height: 3rem;
}

input::placeholder {
    font-size: 0.9rem;
}

input.error {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

input:focus {
    outline: none;
    border-color: #3db8bf;
    box-shadow: 0 0 0 0.2rem rgba(61, 184, 191, 0.25);
}

.password-input {
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
}

.password-toggle {
    position: absolute;
    right: 1rem;
    cursor: pointer;
    color: #757e8a;
    font-size: 1.1rem;
    z-index: 10;
    top: 50%;
    transform: translateY(-50%);
}

.btn-login {
    width: 93%;
    padding: 1rem;
    background-color: #3db8bf;
    color: white;
    border: none;
    border-radius: 0.25rem;
    font-size: 1.1rem;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s;
    margin: 1.5rem 10px;
    height: 3.5rem;
}

.btn-login:hover {
    background-color: #555;
}

.links {
    margin-top: 10px;
    text-align: center;
    display: flex;
    justify-content: end;
    padding: 0px 13px;
}

.links a {
    color: #3db8bf;
    text-decoration: none;
    font-size: 12px;
}

.links a:hover {
    color: #333;
}

.alert {
    padding: 10px;
    border-radius: 4px;
    font-size: 14px;
}

.alert-danger {
    background: #ffe5e5;
    color: #c00;
    border: 1px solid #c00;
}

.alert-success {
    background: #e5ffe5;
    color: #008000;
    border: 1px solid #008000;
}

.field-error {
    color: #dc3545;
    font-size: 0.875rem;
    margin-top: 0.5rem;
    display: flex;
    align-items: center;
    min-height: 1.5rem;
}

.field-success {
    color: #28a745;
    font-size: 0.875rem;
    margin-top: 0.5rem;
    display: flex;
    align-items: center;
    font-weight: 500;
    min-height: 1.5rem;
}

@media (max-width: 48rem) {
    .login-container {
        flex-direction: column;
        min-height: 100vh;
        /* Adiciona o background na versão mobile */
        background-image: url('@/assets/portal/Login-weeduc.png');
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
    }
    
    .banner-side {
        display: none;
    }
    
    .form-side {
        padding: 1.25rem;
        /* Torna o fundo transparente para mostrar o background */
        background-color: rgba(255,255,255,0.90);
        width: 100%;
        min-height: 100vh;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    
    .login-box {
        padding: 1.25rem;
        background: transparent;
        box-shadow: none;
    }
}
.banner-side {
    background-image: url('@/assets/portal/Login-weeduc.png');
    background-size: cover;
    background-position: center;
    background-color: none!important;
}
@media (max-width: 768px) {
    .form-side {
        width: 100%;
        height: 100vh;
    }
}
</style>
